import { ActionsContext } from '../../duck/context';
import { Item } from '../item';
import { Text } from '@chakra-ui/react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, generatePath } from 'react-router-dom';
import { Icon } from '@lon/shared/components';
import { routes } from '@lon/shared/configs';

const Subgroups: React.FC = () => {
  const { t } = useTranslation();
  const { classItem } = useContext(ActionsContext);
  const isArchivedClass = classItem?.archived;

  return (
    <Item
      as={Link}
      className="tr-skip"
      label={
        isArchivedClass
          ? t('classList.classActions.viewSubgroupsTooltip')
          : t('classList.classActions.manageSubgroupsTooltip')
      }
      to={generatePath(routes.classes.show.roster.manageSubgroups.root, {
        classId: classItem?._id,
      })}
    >
      <Icon name="usergroup-edit" size="lg" />
      <Text as="span" variant="s2" className="tr-skip">
        {isArchivedClass
          ? t('classList.classActions.viewSubgroups')
          : t('classList.classActions.manageSubgroups')}
      </Text>
    </Item>
  );
};

export default Subgroups;
